import { z } from 'zod'

import { PriceLineStandard } from './priceLine'

import { Pagination } from 'app/types/app/request'
import { Client, ClientBinding } from 'app/types/park/client'

export const ViewPriceTable = z.enum(['STANDARD', 'CUSTOMISED'])
export type ViewPriceTable = z.infer<typeof ViewPriceTable>

const PriceTable = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    client: ClientBinding,
    standard: z.boolean(),
})

export type PriceTable = z.infer<typeof PriceTable>

const PriceTablesRequest = Pagination.extend({
    results: PriceTable.array(),
})

export type PriceTablesRequest = z.infer<typeof PriceTablesRequest>

export const PriceTableCreatePayload = PriceTable.pick({
    name: true,
}).extend({
    client: Client.shape.id,
})

export type PriceTableCreatePayload = z.infer<typeof PriceTableCreatePayload>

export const PriceTableCreateRequest = PriceTable.pick({
    name: true,
}).extend({
    id: z.number().positive(),
    client: Client,
})

export type PriceTableCreateRequest = z.infer<typeof PriceTableCreateRequest>

export const UpdatePriceTablePayload = z.union([
    z.object({
        lines: PriceLineStandard.array(),
    }),
    z.object({
        name: z.string().min(1),
    }),
])

export type UpdatePriceTablePayload = z.infer<typeof UpdatePriceTablePayload>

export const PriceTableSelected = PriceTable.extend({
    lines: PriceLineStandard.array(),
})

export type PriceTableSelected = z.infer<typeof PriceTableSelected>
